import React, { Component } from 'react';
import H1 from './H1.js';
import axios from 'axios';
import Modal from 'react-modal';
import queryString from 'query-string';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css"; 
import Tab from './Tab.js';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};

class Details extends Component {
    constructor(props) {
        super(props);
        this.state = {
            restaurants: [],
            orderModalIsOpen: false,
            menus: [],
            cart: [],
            selectedRestaurant: null,
        };
    }

    componentDidMount() {
        const qs = queryString.parse(this.props.location.search);
        const { name } = qs;

        axios.get(`https://z-5dan.onrender.com/getkfcrestaurants/?${name}`)
            .then(response => {
                this.setState({ restaurants: response.data }); 
            })
            .catch(error => {
                console.error('Error fetching restaurants:', error);
            });

        axios.get(`https://z-5dan.onrender.com/getallmenus`)
            .then(response => {
                this.setState({ menus: response.data });
            })
            .catch(error => {
                console.error('Error fetching menu items:', error);
            });
    }

    handleLogin = () => {
        this.setState({ orderModalIsOpen: true });
    };

    handleCancel = () => {
        this.setState({ orderModalIsOpen: false });
    };
  
    handleAddToCart = (menuItem) => {
        const { cart } = this.state;
        const existingCartItem = cart.find(item => item.id === menuItem.id);
        
        if (existingCartItem) {
          this.setState(prevState => ({
                cart: prevState.cart.map(item =>
                    item.id === menuItem.id
                        ? { ...item, quantity: item.quantity + 1, subtotal: (item.quantity + 1) * item.price }
                        : item
                ),
            }));
        } else {
            const newCartItem = {
                ...menuItem,
                id: cart.length + 1,
                quantity: 1,
                subtotal: menuItem.price,
            };
            this.setState(prevState => ({
                cart: [...prevState.cart, newCartItem],
            }));
        }
    };

handleRemoveFromCart = (menuItem) => {
    this.setState(prevState => {
        const updatedCart = prevState.cart.map(item => {
            if (item.id === menuItem.id && item.quantity > 1) {
              return { ...item, quantity: item.quantity - 1 };
            }
            return item;
        }).filter(item => item.quantity > 0); 
        
        return { cart: updatedCart };
    });
};

handleRestaurantSelect = (restaurant) => {
        this.setState({ selectedRestaurant: restaurant });
    };

    render() {
        const { restaurants, orderModalIsOpen, selectedRestaurant, cart } = this.state;
        const subtotal = cart.reduce((acc, item) => acc + item.subtotal, 0);

        return (
            <div className='d1'>
                <H1 history={this.props.history} />
                <Carousel showThumbs={false}>
                    <div>
                        <img src="assets/Breakfast.jpg" alt="1" style={{ height: '50vh' }} />
                    </div>
                    <div>
                        <img src="assets/beverages.jpg" alt="2" style={{ height: '50vh' }} />
                    </div>
                    <div>
                        <img src="assets/snack.jpg" alt="3" style={{ height: '50vh' }} />
                    </div>
                </Carousel>
                <div>
                    <button className="btn1" onClick={this.handleLogin}>Place Online Order</button>
                    <div>
                        {restaurants.map((restaurant, index) => (
                            <h1 key={index} style={{ color: "rgb(7, 7, 124)" }}>{restaurant.name}</h1>
                        ))}
                    </div>
                </div>
                <Modal
                    isOpen={orderModalIsOpen}
                    style={customStyles}
                    onRequestClose={this.handleCancel}
                >
                    <h2>{selectedRestaurant ? selectedRestaurant.name + " Menu" : 'Restaurant Menu'}</h2>
                    <div className="menu-container">
                        {selectedRestaurant && selectedRestaurant.menu.map((menuItem, index) => (
                            <div key={index}>
                                <h4>{menuItem.name}</h4>
                                <p>Price: ₹{menuItem.price}</p>
                                <button onClick={() => this.handleAddToCart(menuItem)}>+</button>
                                <button onClick={() => this.handleRemoveFromCart(menuItem)}>-</button>
                            </div>
                        ))}
                    </div>
                    <h3>Sub Total: ₹{subtotal.toFixed(2)}</h3>
                    <div className="container" style={{ backgroundColor: '#f1f1f1' }}>
                        <a href="https://payments-test.cashfree.com/links/S6npqf5okr70" target="_blank" rel="noopener noreferrer">
                            <button style={{ backgroundColor: "blue", fontSize: "20px", color: "white" }}>Pay Now</button>
                        </a>
                        {/* <button style={{ backgroundColor: "blue", fontSize: "20px", color: "white" }}>Pay Now</button> */}
                        <button style={{ marginLeft: "10px", color: "Blue", fontSize: "20px" }} onClick={this.handleCancel}>Cancel</button>
                    </div>
                    {this.state.menus.map((restaurant, index) => (
                        <div key={index} className="restaurant-item" onClick={() => this.handleRestaurantSelect(restaurant)}>
                            <h2>{restaurant.name}</h2>
                        </div>
                    ))}
                </Modal>
                <br />
                <Tab />
            </div>
        );
    }
}

export default Details;
